import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isError, normalize, isPlainObject, addNonEnumerableProperty, logger } from '@sentry/utils';

/** JSDoc */

/** Patch toString calls to return proper name for wrapped functions */
var ExtraErrorData = /*#__PURE__*/function () {
  /** JSDoc */

  /**
   * @inheritDoc
   */
  function ExtraErrorData(options) {
    _classCallCheck(this, ExtraErrorData);
    ;
    ExtraErrorData.prototype.__init.call(this);
    this._options = _objectSpread({
      depth: 3
    }, options);
  }

  /**
   * @inheritDoc
   */
  return _createClass(ExtraErrorData, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = ExtraErrorData.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce(addGlobalEventProcessor, getCurrentHub) {
      addGlobalEventProcessor(function (event, hint) {
        var self = getCurrentHub().getIntegration(ExtraErrorData);
        if (!self) {
          return event;
        }
        return self.enhanceEventWithErrorData(event, hint);
      });
    }

    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */
  }, {
    key: "enhanceEventWithErrorData",
    value: function enhanceEventWithErrorData(event) {
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!hint.originalException || !isError(hint.originalException)) {
        return event;
      }
      var exceptionName = hint.originalException.name || hint.originalException.constructor.name;
      var errorData = this._extractErrorData(hint.originalException);
      if (errorData) {
        var contexts = _objectSpread({}, event.contexts);
        var normalizedErrorData = normalize(errorData, this._options.depth);
        if (isPlainObject(normalizedErrorData)) {
          // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
          // potentially truncate the data we just already normalized, with a certain depth setting.
          addNonEnumerableProperty(normalizedErrorData, '__sentry_skip_normalization__', true);
          contexts[exceptionName] = normalizedErrorData;
        }
        return _objectSpread(_objectSpread({}, event), {}, {
          contexts: contexts
        });
      }
      return event;
    }

    /**
     * Extract extra information from the Error object
     */
  }, {
    key: "_extractErrorData",
    value: function _extractErrorData(error) {
      // We are trying to enhance already existing event, so no harm done if it won't succeed
      try {
        var nativeKeys = ['name', 'message', 'stack', 'line', 'column', 'fileName', 'lineNumber', 'columnNumber', 'toJSON'];
        var extraErrorInfo = {};

        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (var _i = 0, _Object$keys = Object.keys(error); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          if (nativeKeys.indexOf(key) !== -1) {
            continue;
          }
          var value = error[key];
          extraErrorInfo[key] = isError(value) ? value.toString() : value;
        }

        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
          var serializedError = error.toJSON();
          for (var _i2 = 0, _Object$keys2 = Object.keys(serializedError); _i2 < _Object$keys2.length; _i2++) {
            var _key = _Object$keys2[_i2];
            var _value = serializedError[_key];
            extraErrorInfo[_key] = isError(_value) ? _value.toString() : _value;
          }
        }
        return extraErrorInfo;
      } catch (oO) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Unable to extract extra data from the Error object:', oO);
      }
      return null;
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'ExtraErrorData';
    }
  }]);
}();
ExtraErrorData.__initStatic();
export { ExtraErrorData };